import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
// Moved from polyfills.ts to main.ts for proper support of UMD bundle which contains polyfills.
// Revert this change to use project module bundle.
import 'zone.js'; // Included with Angular CLI.

//Démarrage de l'application
platformBrowserDynamic().bootstrapModule(AppModule);